import { Component, Input } from '@angular/core';
import { SLEntityVersion } from '../entity';

@Component({
  selector: 'sl-entity-blockchain',
  templateUrl: './entity-blockchain.component.html',
})
export class SLEntityBlockchainComponent {

  @Input()
  entity: SLEntityVersion
}
